import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

/**
 * Guard to restrict unauthorized access to payment-related pages.
 */
export const PaymentGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const router = inject(Router);
  const authService = inject(AuthService);

  // Check if the user has the necessary account ownership permissions
  if (!authService.isAccountOwner()) {
    alert('You are not permitted to access this page!');
    return router.createUrlTree(['/signin']);
  }

  return true;
};
